import { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Form } from 'redux-form';

import { getDefaultCountryCode } from 'common/helpers/miscHelper';
import { phoneFormatForDB } from 'common/helpers/phoneHelper';
import { submitResponse } from 'redux/forms/actions';
import { getFormByCode } from 'redux/forms/reducers';

import FormSuccess from './FormSuccess';
import FormCustomer from './components/FormCustomer';
import FormMetaData from './components/FormMetaData';
import FormQuestions from './components/FormQuestions';
import { transformMetaData, transformQuestions } from './helpers';
import { validateSubmit } from './validators';

class C7Form extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      formSubmitted: false
    };
  }

  handleSubmit = (form) => {
    const { props } = this;
    const data = transformData(form, props);
    const successFunction = () => {
      this.setState({
        formSubmitted: true
      });
    };
    const failFunction = () => {
      this.setState({
        error: 'Unfortunately there was an error submitting the form.'
      });
    };
    props.submitResponse(data, props.c7Form.id, successFunction, failFunction);
  };

  render() {
    const { state, props } = this;
    const { handleSubmit, c7Form, node } = props;
    const { customerMetaData, customer, settings } = props;
    // Remove min-height after loaded

    node.style.minHeight = 0;
    if (!state.formSubmitted) {
      return (
        <Form
          onSubmit={handleSubmit(this.handleSubmit)}
          className="c7-form"
          method="post"
        >
          <FormCustomer
            c7Form={c7Form}
            customer={customer.data}
            settings={settings}
          />
          <FormMetaData c7Form={c7Form} customerMetaData={customerMetaData} />
          <FormQuestions c7Form={c7Form} />
          <div className="c7-form__button-row">
            <button type="submit" className="c7-button">
              Submit
            </button>
          </div>
          {state.error && (
            <span className="c7-message--error">Error: {state.error}</span>
          )}
        </Form>
      );
    }

    return <FormSuccess thankYouMessage={c7Form.thankYouMessage} />;
  }
}

const transformData = (values, ownProps) => {
  const { c7Form, customerMetaData } = ownProps;
  if (!c7Form) {
    return null;
  }
  const { customerAttributes } = c7Form;

  const data = { email: values.email };
  if (customerAttributes.firstName) {
    data.firstName = values.firstName;
  }
  if (customerAttributes.lastName) {
    data.lastName = values.lastName;
  }
  if (customerAttributes.countryCode) {
    data.countryCode = values.countryCode;
  }
  if (customerAttributes.phone) {
    data.phone = phoneFormatForDB(values.phone, values.countryCode);
  }
  if (
    customerAttributes.emailMarketingStatus &&
    values.emailMarketingStatus !== ''
  ) {
    data.emailMarketingStatus = values.emailMarketingStatus;
  }
  const metaData = transformMetaData(values, c7Form, customerMetaData);
  data.metaData = metaData;
  const questions = transformQuestions(values, c7Form);
  data.questions = questions;

  return data;
};

const validate = (values, ownProps) => {
  const data = transformData(values, ownProps);
  const errors = validateSubmit(
    data,
    ownProps.c7Form,
    ownProps.customerMetaData,
    ownProps.settings
  );
  return errors;
};

const mapStateToProps = (state, ownProps) => {
  const initialValues = {
    countryCode: getDefaultCountryCode(state.setting)
  };
  const c7Form = getFormByCode(state.forms, ownProps.code);
  if (c7Form?.metaDataAttributes?.length > 0) {
    const metaDataIdArray = Object.keys(state.customerMetaData.data);
    const metaDataArray = metaDataIdArray.map(
      (id) => state.customerMetaData.data[id]
    );
    c7Form.metaDataAttributes.forEach((metaDataCode) => {
      const metaDataElement = metaDataArray.find(
        (metaData) => metaData.code === metaDataCode
      );
      const dataField = ownProps.node.getAttribute(
        `data-field-meta-${metaDataCode}`
      );
      if (metaDataElement && dataField) {
        initialValues[`metaData-${ownProps.form}-${metaDataElement.id}`] =
          dataField;
      }
    });
  }
  if (c7Form?.questions) {
    c7Form.questions.forEach((question) => {
      const dataField = ownProps.node.getAttribute(
        `data-field-question-${question.code}`
      );
      if (dataField) {
        initialValues[`question-${question.id}`] = dataField;
      }
    });
  }

  return {
    c7Form,
    customer: state.customer,
    customerMetaData: state.customerMetaData,
    initialValues,
    settings: state.setting
  };
};

C7Form = reduxForm({
  // form: props.form,
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate
})(C7Form);

export default connect(mapStateToProps, { submitResponse })(C7Form);
